import type { PackageState } from "../slice";

export const getSearchFormOrigin = (state: PackageState) =>
  state.packages.search.searchFormValues.origin;

export const getSearchFormDestination = (state: PackageState) =>
  state.packages.search.searchFormValues.destination;

export const getSearchFormGuests = (state: PackageState) =>
  state.packages.search.searchFormValues.guests;

export const getSearchFormDateRange = (state: PackageState) =>
  state.packages.search.searchFormValues.dateRange;

export const getSearchFormRoomCount = (state: PackageState) =>
  state.packages.search.searchFormValues.roomCount;

export const getSearch = (state: PackageState) => state.packages.search.search;

export const getRequestedSearch = (state: PackageState) =>
  state.packages.search.requestedSearch;

export const getSearchFormValues = (state: PackageState) =>
  state.packages.search.searchFormValues;

export const getSearchFormPackageType = (state: PackageState) =>
  state.packages.search.searchFormValues.packageType;

export const getSearchFormDriverAge = (state: PackageState) =>
  state.packages.search.searchFormValues.driverAge;

export const getSearchFormPassengerCount = (state: PackageState) => {
  const travelers = getSearchFormGuests(state);
  return (
    travelers.adultCount +
    travelers.childAges.length +
    travelers.infantOnLapAges.length +
    travelers.infantInSeatAges.length
  );
};

export const getInitializedState = (state: PackageState) =>
  state.packages.search.initialized;
